import React from "react";

import { Divider, Button, Loading } from "../Controls";

import texts from "../../assets/strings/success.js";
import { hashHistory } from "react-router";

const SuccessMobile = props => (
  <div className="confirmation mobile">
    <h1 style={{ fontSize: 35 }}>{texts.title}</h1>
    <h2 style={{ margin: 25, lineHeight: 1.5 }}>{texts.h1}</h2>
    <div className="note">{texts.h3}</div>
    <div className="note">
      <Button
        primary={true}
        large={true}
        onClick={() => window.location.reload()}
      >
        <span>{texts.done}</span>
      </Button>
    </div>
  </div>
);

export default SuccessMobile;



// WEBPACK FOOTER //
// ./components/Review/SuccessMobile.js